import type { CSSProperties } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { Avi } from '../ui/Avi';
import { CatalogUpload } from '../catalog/CatalogUpload';
import { SupportModeBanner } from '../support/SupportModeBanner';
import { darkTheme, FONT, GRAD } from '../../theme/tokens';
import { welcomeCopy } from '../../copy/welcome';

const t = darkTheme;

const fadeIn = (delayMs: number): CSSProperties => ({
  animation: 'fadeInUp 400ms ease-out backwards',
  animationDelay: `${delayMs}ms`,
});

export function WelcomePage() {
  const { isAuthenticated, isLoading } = useAuth();
  if (isLoading) return null; // ProtectedRoute already shows the spinner; nothing to add here.
  if (!isAuthenticated) return <Navigate to="/login" replace />;

  return (
    <div style={{ minHeight: '100vh', background: 'var(--bg)', display: 'flex', flexDirection: 'column' }}>
      {/* Staff can land here inside a client org that has no catalog yet (e.g.
          helping with onboarding) — support mode must stay visible (SC-2948). */}
      <SupportModeBanner />
      <div
        style={{
          flex: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontFamily: FONT,
          padding: '40px 24px',
        }}
      >
        <div style={{ width: '100%', maxWidth: 480 }}>
          {/* Brand */}
          <div style={{ display: 'flex', alignItems: 'center', gap: 14, marginBottom: 32, ...fadeIn(0) }}>
            <Avi size={40} />
            <div>
              <div style={{ background: GRAD, WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', fontWeight: 700, fontSize: 22, lineHeight: 1.1 }}>
                {welcomeCopy.brand.name}
              </div>
              <div style={{ color: t.text2, fontSize: 12, marginTop: 2 }}>
                {welcomeCopy.brand.tagline}
              </div>
            </div>
          </div>

          {/* Hero + subhead */}
          <h1 style={{ color: t.text, fontSize: 28, fontWeight: 600, margin: '0 0 8px', ...fadeIn(80) }}>
            {welcomeCopy.hero}
          </h1>
          <p style={{ color: t.text2, fontSize: 14, lineHeight: 1.5, margin: '0 0 28px', ...fadeIn(160) }}>
            {welcomeCopy.subhead}
          </p>

          {/* Upload card */}
          <div style={fadeIn(240)}>
            <CatalogUpload variant="card" />
          </div>
        </div>
      </div>
    </div>
  );
}
